<template>
  <CCard class="mb-4">
    <CCardHeader class="bg-transparent border-0 p-4">
      <h2 class="h6 font-weight-bold mb-0">Quotation summary</h2>
    </CCardHeader>
    <CCardBody class="p-4">
      <div class="d-flex justify-content-between mb-3">
        <div class="text-muted">Subtotal</div>
        <div class="font-weight-bold text-right">RM {{ formatMyr(grandTotal) }}</div>
      </div>
      <div class="d-flex justify-content-between mb-3">
        <div class="text-muted">
          Tax{{ selectedSalesTax ? ` (${selectedSalesTax.name})` : " (0%)" }}
        </div>
        <div class="font-weight-bold text-right">RM {{ formatMyr(grandTaxOnly) }}</div>
      </div>
      <hr class="my-3" />
      <div class="d-flex justify-content-between mb-3">
        <div class="font-weight-bold">Grand total</div>
        <div class="font-weight-bold h4 text-right">
          RM {{ formatMyr(grandTotalWithTax) }}
        </div>
      </div>

      <CButton color="light" block class="mt-3" @click="$emit('print-quotation')">
        <CIcon name="cil-print" /> Print quotation
      </CButton>
      <CButton
        v-if="canDownload"
        color="primary"
        variant="outline"
        block
        class="mt-2"
        :disabled="downloading"
        @click="$emit('export-pdf')"
      >
        <CIcon name="cil-cloud-download" />
        {{ downloading ? "Preparing PDF…" : "Download PDF" }}
      </CButton>
    </CCardBody>
  </CCard>
</template>

<script>
import { formatMyr } from "@/utils/money";

export default {
  name: "QuotationSummaryComponent",
  props: {
    grandTotal: {
      type: Number,
      default: 0,
    },
    grandTaxOnly: {
      type: Number,
      default: 0,
    },
    grandTotalWithTax: {
      type: Number,
      default: 0,
    },
    selectedSalesTax: {
      type: Object,
      default: null,
    },
    // Download PDF is only offered for a saved quotation (the PDF is generated by the API).
    canDownload: {
      type: Boolean,
      default: false,
    },
    downloading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatMyr,
  },
};
</script>
